import axios from "../services/axios";
import parseError from "../../utils/errorParse";
import { jwtDecode } from "jwt-decode";

let refre = 0;

function isTokenAboutToExpire(expiryTime) {
  const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds since epoch
  const timeRemaining = expiryTime - currentTime;
  return timeRemaining <= 1800 && timeRemaining > 0;
}

function withAPIKeys(params) {
  var tenantId = params?.tenantId;
  var forcedToken = params?.forcedToken;
  if(forcedToken){
    return {
      headers: {
        Authorization: `Bearer ${forcedToken}`,
        "Content-Type": "application/json"
      },
    };
  }
  let tokenNew = null;
  if (refre === 0) {
    refre = 1;
    setTimeout(() => {
      refre = 0;
    }, 10000);
    (async () => {
      try {
        const accessToken = localStorage?.getItem("accessToken");
        const refreshToken = localStorage?.getItem("refreshToken");
        const decodedToken = accessToken && jwtDecode(JSON.parse(accessToken));

        if (isTokenAboutToExpire(decodedToken?.exp)) {
          const payload = JSON.stringify({
            accessToken: accessToken?.replace(/"/g, ""),
            refreshToken: refreshToken?.replace(/"/g, ""),
          });
          const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken?.replace(/"/g, "")}`,
          };

          const response = await fetch(
            `${process.env.REACT_APP_API_URL}token/refresh`,
            {
              method: "POST",
              headers: headers,
              body: payload,
            }
          );

          if (response?.status === 200) {
            const data = await response?.json();
            console.log(data, "new token fetching");
            tokenNew = data?.accessToken;
            localStorage.setItem(
              "accessToken",
              JSON.stringify(data?.accessToken)
            );
            localStorage.setItem(
              "refreshToken",
              JSON.stringify(data?.refreshToken)
            );
          }
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }
  const token = localStorage.getItem("accessToken");
  if (tokenNew) {
    return {
      headers: {
        Authorization: `Bearer ${tokenNew}`,
        "Content-Type": "application/json",
        ...(tenantId && { "Tenant-ID": tenantId }),
      },
    };
  } else if (token) {
    return {
      headers: {
        Authorization: `Bearer ${token.replace(/"/g, "")}`,
        "Content-Type": "application/json",
        ...(tenantId && { "Tenant-ID": tenantId }),
      },
    };
  } else {
    return {
      headers: {
        "Content-Type": "application/json",
        ...(tenantId && { "Tenant-ID": tenantId }),
      },
    };
  }
}

function withMultipartAPIKeys() {
  let tokenNew = null;
  if (refre === 0) {
    refre = 1;
    setTimeout(() => {
      refre = 0;
    }, 10000);
    (async () => {
      try {
        const accessToken = localStorage?.getItem("accessToken");
        const refreshToken = localStorage?.getItem("refreshToken");
        // console.log(accessToken, refreshToken);
        const decodedToken = accessToken && jwtDecode(JSON.parse(accessToken));
        // localStorage.setItem("refreshFlag", JSON.stringify(false));

        if (isTokenAboutToExpire(decodedToken?.exp)) {
          const payload = JSON.stringify({
            accessToken: accessToken?.replace(/"/g, ""),
            refreshToken: refreshToken?.replace(/"/g, ""),
          });
          const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken?.replace(/"/g, "")}`,
          };

          // localStorage.setItem("refreshFlag", JSON.stringify(true));

          const response = await fetch(
            `${process.env.REACT_APP_API_URL}token/refresh`,
            {
              method: "POST",
              headers: headers,
              body: payload,
            }
          );

          if (response?.status === 200) {
            const data = await response?.json();
            console.log(data, "new token fetching");
            tokenNew = data?.accessToken;
            localStorage.setItem(
              "accessToken",
              JSON.stringify(data?.accessToken)
            );
            localStorage.setItem(
              "refreshToken",
              JSON.stringify(data?.refreshToken)
            );
            // localStorage.setItem("refreshFlag", JSON.stringify(false));
          }
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }
  const token = localStorage.getItem("accessToken");
  if (tokenNew) {
    return {
      headers: {
        Authorization: `Bearer ${tokenNew}`,
        "Content-Type": "application/json",
      },
    };
  } else if (token) {
    return {
      headers: {
        Authorization: `Bearer ${token.replace(/"/g, "")}`,
        "Content-Type": "multipart/form-data",
      },
    };
  }
  return {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
}

function CustomHeadersForPdf() {
  const token = localStorage.getItem("accessToken");
  return {
    headers: {
      Authorization: `Bearer ${token.replace(/"/g, "")}`,
      Accept: "application/pdf",
    },
    responseType: "blob",
  };
}

const addPageNumber = (url, params) => {
  let str = "";
  if (params.pageNumber) {
    str = `pageNumber=${params.pageNumber}`;
  }
  if (params.pageSize) {
    str = `${str}${str ? "&" : ""}pageSize=${params.pageSize}`;
  }

  return str ? `${url}?${str}` : url;
};

export const apiCall = {
  pagination: (payload) =>
    axios
      .get(payload.url, withAPIKeys())
      .then((response) => response)
      .catch((error) => parseError(error)),
  get: (payload) =>
    axios
      .get(payload.url, withAPIKeys(payload.tenantId))
      .then((response) => {
        return response.data;
      })
      .catch((error) => parseError(error)),
  post: (payload) =>
    axios
      .post(payload.url, payload.params, withAPIKeys({tenantId: payload.tenantId, forcedToken: payload.forcedToken}))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        const err = parseError(error);
        throw err;
        // throw new Error(JSON.stringify(err.data));
        // throw new Error(JSON.stringify(err.data.errors));
      }),
  put: (payload) =>
    axios
      .put(payload.url, payload.params, withAPIKeys())
      .then((response) => response.data)
      .catch((error) => {
        const err = parseError(error);
        throw err;
      }),
  patch: (payload) =>
    axios
      .patch(payload.url, payload.params, withAPIKeys())
      .then((response) => response.data)
      .catch((error) => {
        const err = parseError(error);
        throw err;
      }),
  delete: (payload) =>
    axios
      .delete(payload.url, withAPIKeys())
      .then((response) => response.data)
      .catch((error) => {
        const err = parseError(error);
        // throw new Error(err.data.message);
        throw err;
      }),
  file: (payload) =>
    axios
      .put(payload.url, payload.params, withMultipartAPIKeys())
      .then((response) => response.data)
      .catch((error) => parseError(error)),
  filePost: (payload) =>
    axios
      .post(payload.url, payload.params, withMultipartAPIKeys())
      .then((response) => response.data)
      .catch((error) => parseError(error)),
  pdf: (payload) =>
    axios
      .get(payload.url, CustomHeadersForPdf())
      .then((response) => response.data)
      .catch((error) => parseError(error)),
  pdfPost: (payload) =>
    axios
      .post(payload.url,payload.params, CustomHeadersForPdf())
      .then((response) => response.data)
      .catch((error) => parseError(error)),
  getFile: (payload) =>
    axios
      .get(payload.url, {headers: {...payload.headers, Authorization: `Bearer ${localStorage.getItem("accessToken").replace(/"/g, "")}`}, responseType: payload.responseType})
      .then((response) => response)
      .catch((error) => parseError(error)),
};

export const isTokenValid = () => {
  const accessToken = localStorage.getItem("accessToken");
  if (!accessToken) return false;

  try {
    const decoded = jwtDecode(accessToken);
    const currentTime = Math.floor(Date.now() / 1000);
    return decoded.exp > currentTime;
  } catch (error) {
    console.error("Invalid token", error);
    return false;
  }
};

export const buildQueryParams = (queryObject) => {
  const params = new URLSearchParams();
  for (const key in queryObject) {
    const value = queryObject[key];
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, value);
    }
  }

  return params.toString();
};
export const handleLogout = () => {
  localStorage.clear();
  window.location.href = "/login";
};
